import { Badge, Text } from '@mantine/core';
import { useState, useEffect, useMemo } from 'react';
import styled from '@emotion/styled';

import { axios } from '../../../../utils/axios';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 5px;
  align-items: flex-start;
`;

const ReferenceSku = ({ label, sku, plant, description }) => (
  <Badge size='lg'>
    <Text size={16} color='black'>
      {label}: {sku} | {plant} | {description}
    </Text>
  </Badge>
);

export const RefBadge = ({ crNumber, activePlant, dualReferenceSku = false }) => {
  const [fetchedData, setFetchedData] = useState(null);

  useEffect(() => {
    const getSelectedRef = async () => {
      try {
        const { data } = await axios.get(
          `/costing-request/step/selected-ref-sku-selection/${crNumber}`,
        );
        setFetchedData(data);
      } catch (e) {
        console.error('Error fetching reference SKU:', e);
      }
    };

    if (crNumber) {
      getSelectedRef();
    }
  }, [crNumber]);

  // Memoized value to prevent unnecessary re-renders
  const refSku = useMemo(() => {
    if ((!fetchedData || fetchedData.length === 0) && activePlant) {
      return { sku: '--', sku_description: '--', prod_plant: '--' };
    }
    const primaryRef = fetchedData?.filter(
      (ele) => ele?.plant_data?.producing_plant === activePlant,
    );

    const { sku_details, secondary_sku_details } = primaryRef?.[0] || {};
    return {
      sku: sku_details?.sku || '--',
      sku_description: sku_details?.sku_description || '--',
      prod_plant: sku_details?.plant || '--',
      secondary_sku: secondary_sku_details?.sku || null,
      secondary_sku_description: secondary_sku_details?.sku_description || null,
      secondary_prod_plant: secondary_sku_details?.plant || null,
    };
  }, [fetchedData, activePlant]);

  return (
    <Container>
      <ReferenceSku
        label={refSku.secondary_sku ? 'Packaging Ref' : 'Ref'}
        sku={refSku.sku}
        plant={refSku.prod_plant}
        description={refSku.sku_description}
      />
      {refSku.secondary_sku && dualReferenceSku && (
        <ReferenceSku
          label={'Brewing Ref'}
          sku={refSku.secondary_sku}
          plant={refSku.secondary_prod_plant}
          description={refSku.secondary_sku_description}
        />
      )}
    </Container>
  );
};
